
import { defineComponent } from 'vue';
import PDialog from 'primevue/dialog';
import PButton from 'primevue/button';

/**
 * General modal component with title, description, configurable content and optional footer with two buttons
 */

export default defineComponent({
  name: 'BActionsModal',
  components: {
    PDialog,
    PButton
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: null
    },
    confirmText: {
      type: String,
      default: null
    },
    hasDeleteButton: {
      type: Boolean,
      default: false
    },
    hasFooter: {
      type: Boolean,
      default: true
    },
    confirmDisabled: {
      type: Boolean,
      default: false
    },
    cypressPrefix: {
      type: String,
      default: ''
    },
    dismissableMask: {
      type: Boolean,
      default: true
    }
  },
  emits: ['close', 'confirm'],
  data() {
    return {
      modalVisible: this.showModal
    };
  },
  computed: {
    confirmTextLabel(): string {
      return this.confirmText ?? this.$t('actions.confirm');
    },
    cancelTextLabel(): string {
      return this.cancelText ?? this.$t('actions.cancel');
    }
  },
  watch: {
    showModal(newValue): void {
      this.modalVisible = newValue;
    }
  },
  methods: {
    closeModal(): void {
      this.$emit('close');
    },
    confirm(): void {
      this.$emit('confirm');
    }
  }
});
